import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarCheck, ArrowUpRight } from "lucide-react";
import { LeadForm } from "@/components/site/LeadForm";

export const ClosingConversion = () => (
  <section data-testid="closing-conversion" className="bg-[#E7DECE] py-14 md:py-20">
    <div className="container-lr">
      <div className="grid gap-6 lg:grid-cols-[55fr_45fr] lg:items-stretch">
        {/* Newsletter card */}
        <div id="newsletter" data-testid="mastering-money-section" className="lr-card flex flex-col justify-center bg-[#F2EBDC] p-7 md:p-9">
          <p className="eyebrow text-bronze">Our Weekly Newsletter</p>
          <h2 className="mt-3 font-serif font-semibold leading-[1.03] tracking-display text-legacy text-3xl md:text-4xl lg:text-[2.75rem]">Mastering Money <span className="accent-word">Mondays</span></h2>
          <p className="mt-3 font-serif text-lg italic leading-snug text-bronze md:text-xl">Build a better financial system. One Monday at a time.</p>
          <div className="mt-6">
            <LeadForm
              list="Weekly newsletter sign ups"
              source="home"
              layout="inline"
              submitLabel="Count Me In"
              showDisclosure={false}
              note="A weekly newsletter — not a gated download. Unsubscribe anytime."
              successTitle="Welcome to Mastering Money Mondays!"
              successMessage="Your first issue will arrive next Monday. In the meantime, explore our free educational resources and start building your family’s financial system."
            />
          </div>
        </div>

        {/* Build With Intention card */}
        <motion.div
          id="strategy-call"
          data-testid="cta-section"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="relative flex flex-col justify-center overflow-hidden rounded-card bg-legacy p-8 text-center md:p-9"
        >
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_82%_20%,rgba(197,161,90,0.22),transparent_30%),linear-gradient(90deg,rgba(17,17,17,0.15),rgba(17,17,17,0.72))]" />
          <div className="relative mx-auto max-w-md">
            <p className="eyebrow text-gold">Build With Intention</p>
            <h2 className="mt-3 font-serif font-semibold tracking-display text-ivory text-2xl leading-[1.14] md:text-[1.75rem]">Your financial life should work as one coordinated system.</h2>
            <p className="mt-3 text-sm leading-relaxed text-taupe md:text-base">Start with a straightforward conversation about where your family is today, what you are trying to build, and which part of the system deserves attention first.</p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
              <Link to="/strategy-call" data-testid="cta-primary-button" className="btn-base btn-gold"><CalendarCheck size={18} />Book Your Free Strategy Call</Link>
              <Link to="/resources" data-testid="cta-secondary-button" className="btn-base btn-outline-light">Explore Free Resources <ArrowUpRight size={17} /></Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
